import { BackgroundController, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { gameConstants } from "../Constants/gameConstants";

export class BackgroundControllerGame extends BackgroundController {
  protected changeBackground(evt: any): void {
    this.hideAllBg();
    if (evt.data === gameConstants.FREEGAME_INTRO_BG) {
      this.basegameBgContainer.visible = true;
    } else {
      super.changeBackground(evt);
    }
  }
  /**
   * to stop fg bg spine
   */
  protected showFreeGameBg(): void {
    this.freegameBgContainer.visible = true;
    const freeGameBG = this.view.getSpineById("freegameBackground");
    freeGameBG.playAnim("freegame_idle_desktop", true);
    if (!ingenuity.deviceEnv.isDesktop) {
      const freeGameBGPort = this.view.getSpineById("freegameBackgroundPortrait")
      freeGameBGPort && freeGameBGPort.setPause(false);
      freeGameBGPort && freeGameBGPort.playAnim("freegame_idle_portrait", true);
    }
  }

  protected showSelectionScreenBg(): void {
    this.selectionScreenBGContainer.visible = true;
    const selectionScreenBG = this.view.getSpineById("selectionScreen_idle");
    selectionScreenBG.playAnim("selection_screen_desktop", true);
    if (!ingenuity.deviceEnv.isDesktop) {
      const selectionBGPort = this.view.getSpineById("selectionScreen_idle_port")
      selectionBGPort && selectionBGPort.setPause(false);
      selectionBGPort && selectionBGPort.playAnim("selection_screen_portrait", true);
    }
  }
  protected playBasegameIdleSpine(): void {
    this.basegameBgSpineContainer.visible = true;
    this.basegameIldeSpine && this.basegameIldeSpine.setPause(false);
    this.basegameIldeSpine.playAnim(SlotConstantsBehavior.BASEGAME_IDLE_SPINE, true);
    if (!ingenuity.deviceEnv.isDesktop) {
      this.basegameIldePortraitSpine && this.basegameIldePortraitSpine.setPause(false);
      this.basegameIldePortraitSpine && this.basegameIldePortraitSpine.playAnim("basegame_idle_portrait", true);
    }
  }
}
